import * as React from "react"
import Svg, {Defs, LinearGradient, Path, Stop} from "react-native-svg"
import {View} from "react-native";
import {useContext} from "react";
import AppConfigContext from "../../../contexts/AppConfigContext";
import {Colors} from "../colors";

const MainHeader = React.memo((props: any) => {
    return <View style={[{height: props.height}, props.style]}>
        <SVG style={{position: "absolute", bottom: 0, zIndex: -1}}/>
    </View>
});

function SVG(props: any) {
    const colors = Colors.instanceNoServerColor(useContext(AppConfigContext).theme, useContext(AppConfigContext).color);
    return (
        <Svg
            viewBox="0 0 360 105"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <Path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M360 91.523C306.57 100.115 245.23 105 180 105S53.43 100.115 0 91.523V0h360v91.523z"
                fill="url(#paint0_linear_776_4242)"
            />
            <Defs>
                <LinearGradient
                    id="paint0_linear_776_4242"
                    x1={244}
                    y1={6}
                    x2={244.429}
                    y2={106.321}
                    gradientUnits="userSpaceOnUse"
                >
                    <Stop stopColor={(colors.get("primaryColor") as string)} />
                    <Stop offset={1} stopColor={colors.get("primaryColor") as string} />
                </LinearGradient>
            </Defs>
        </Svg> )
}

export default MainHeader
